module.exports = __webpack_public_path__ + "img/ck.580d8303.png";